webpackJsonp([5],{

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initTracking; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_global_log_engagement__ = __webpack_require__(27);

var initTracking = function initTracking($rowEl) {
  var code = $rowEl.data('code');
  $rowEl.find('.js-track-save').on('click', function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'shopping bag', 'Save For Later', code);
  });
  $rowEl.find('.js-track-favorite').on('click', function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'shopping bag', 'Move To Favorites', code);
  });
  $rowEl.find('.js-track-remove').on('click', function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'shopping bag', 'Remove', code);
  });
  $rowEl.find('.js-track-edit').on('click', function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'shopping bag', 'Edit', code);
  });
};

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_social_proof__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracking__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styleguide_modules_slick_custom_paging__ = __webpack_require__(25);





function applyCouponCode(couponCode, isAutoApply) {
  __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-promo-error-msg').removeClass('is-error');
  __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#promocode-error').text('').hide();
  if (couponCode === "") {
    couponCode = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#promo').val();
  }
  if (couponCode) {
    var successCallBack = function successCallBack(obj) {
      if (obj.success) {
        // coupon applied ok but applied with restriction or with 0 amount
        if (!obj.msg10) {
          // coupon not applied
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#coupon_applied_invalid').html(obj.msg14 || obj.msg9).slideDown();
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#summary_coupon').hide();
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#summary_coupon_code').text('').hide();
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.coupon_applied').hide();
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#promo').val('');
          if (obj.msg15) {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#totalAfterPayPayment').html(obj.msg15);
          }
          return;
        } else if (obj.msg4) {
          // invalid promo code
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#coupon_applied_invalid').html('');
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#summary_coupon').hide();
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#total').text(obj.msg3);
        } else {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#promo').data('applied-coupon-code', couponCode);
          if (obj.msg14) {
            // for restrictions
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#coupon_applied_invalid').html(obj.msg14 || obj.msg9).slideDown();
          } else {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#coupon_applied_invalid').html('').hide();
          }
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#discountAmount').html(obj.msg2);
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#summary_coupon').show();
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#summary_coupon_code').text('Promo Code: ' + couponCode).show();
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#summary_coupon_amount').text(obj.msg2).show();
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#total').text(obj.msg3);
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.coupon_applied').show();
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#promo').val('');
          if (obj.msg15) {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#totalAfterPayPayment').html(obj.msg15);
          }
        }
        if (typeof isAutoApply == "undefined" || !isAutoApply) {
          updateMiniBag(false);
        }
      } else {
        // Invalid coupon code.
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-promo-error-msg').addClass('is-error');
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#promocode-error').text(obj.msg4 ? obj.msg4 : 'Invalid code').show();
        if (obj.msg15) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#totalAfterPayPayment').html(obj.msg15);
        }
      }
    };
    applyPromo(couponCode, successCallBack);
  }
}
function removeCoupon() {
  var successCallBack = function successCallBack(obj) {
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#summary_coupon').hide();
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#coupon_applied_invalid').html('').hide();
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#summary_coupon_code').text('');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#summary_coupon_amount').text('');
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#total').text(obj.msg3);
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.coupon_applied').hide();
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#promo').data('applied-coupon-code', "");
    if (obj.msg15) {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#totalAfterPayPayment').html(obj.msg15);
    }
    updateMiniBag(false);
  };
  applyPromo("", successCallBack);
}
function initSizeSelector() {
  // Load HTML content and then show popup
  __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-sb-add-to-bag-size').on('click', function (event) {
    var clickedButton = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this); // Store reference to clicked button
    var code = clickedButton.data('code');
    // Load the HTML content first
    __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
      url: '/r/ajax/GetProductSizeMenu.jsp?code=' + code,
      type: 'GET',
      success: function success(htmlContent) {
        var target = document.querySelector('#sb-rec-size-menu-container');
        // Insert the HTML into container
        target.innerHTML = htmlContent;
        // THEN position and show the popup
        var atbPosition = clickedButton.offset();
        var containerPosition = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.product-recs__wrap').offset();
        var popOver = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-select-size-menu');
        var middlePointX = atbPosition.left - containerPosition.left;
        var atbPositionLeft = middlePointX - 92;
        if (popOver.width() < 234) {
          atbPositionLeft = middlePointX - 50;
          var popOverSizes = popOver.children('ul').eq(0);
          popOverSizes.removeClass('n-block-grid--3');
          popOverSizes.addClass('n-block-grid--2');
        }
        popOver.css({
          'left': atbPositionLeft,
          'display': 'block'
        });
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.popover__header').focus();
        __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].trapFocus(popOver);
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-modal').modal();
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-size-select-btn').click(function (e) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-size-menu-error').addClass('u-hide');
          var code = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).data('code');
          var sizeElement = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('input[name="size-selection-op-' + code + '"]:checked');
          var sizeCode = sizeElement.data('sizeCode');
          var size = sizeElement.data('size');
          if (sizeCode && size) {
            addBeautyAddOns(sizeCode, size, false, event);
            target.innerHTML = '';
          } else {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-size-menu-error').removeClass('u-hide');
          }
        });
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-size-select').on('click', function () {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-size-menu-error').addClass('u-hide');
        });
      },
      error: function error(xhr, status, _error) {
        console.error('Failed to load HTML:', _error);
      }
    });

    // Stop propagation to prevent immediate closing
    event.stopPropagation();
  });

  // Document click handler to close popover when clicking outside
  __WEBPACK_IMPORTED_MODULE_2_jquery___default()(document).on('click', function (event) {
    var popOver = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-select-size-menu');
    if (!__WEBPACK_IMPORTED_MODULE_2_jquery___default()(event.target).closest('.js-select-size-menu, .js-sb-add-to-bag-size').length) {
      __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].releaseFocus(popOver, __WEBPACK_IMPORTED_MODULE_2_jquery___default()(popOver.data('lastFocus')));
      popOver.css('display', 'none');
    }
  });

  // Escape key handler to close popover
  __WEBPACK_IMPORTED_MODULE_2_jquery___default()(document).on('keydown', function (event) {
    var popOver = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-select-size-menu');
    if (event.which === 27 || event.keyCode === 27) {
      __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].releaseFocus(popOver, __WEBPACK_IMPORTED_MODULE_2_jquery___default()(popOver.data('lastFocus')));
      popOver.css('display', 'none');
    }
  });
}
__WEBPACK_IMPORTED_MODULE_2_jquery___default()(function () {
  __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#recently-viewed').lazyAjax({
    afterLoad: function afterLoad($el) {
      if (__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-carousel--centered').length > 0) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-carousel--centered').slickSlider({
          dots: true,
          customPaging: __WEBPACK_IMPORTED_MODULE_4_styleguide_modules_slick_custom_paging__["a" /* default */],
          dotsClass: "image-carousel__dots",
          appendDots: __WEBPACK_IMPORTED_MODULE_2_jquery___default()(".image-carousel__dots-container--centered")
        });
      }
      if (__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-carousel--centered--ab').length > 0) {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-carousel--centered--ab').slickSlider({
          dots: true,
          customPaging: __WEBPACK_IMPORTED_MODULE_4_styleguide_modules_slick_custom_paging__["a" /* default */],
          dotsClass: "image-carousel__dots",
          appendDots: __WEBPACK_IMPORTED_MODULE_2_jquery___default()(".image-carousel__dots-container--centered"),
          slidesToShow: 8,
          slidesToScroll: 8,
          responsive: [{
            breakpoint: 1027,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5
            }
          }]
        });
      }
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-lazy-image').lazy({
        effect: 'fadeIn'
      });
      initSizeSelector();
    }
  });
  __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-lazy-image').lazy({
    effect: 'fadeIn'
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__modules_social_proof__["a" /* renderCartSocialProof */])(__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-cart-item').toArray().map(function (el) {
    return __WEBPACK_IMPORTED_MODULE_2_jquery___default()(el).data('code');
  }));
  __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-cart-item').each(function (i, el) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tracking__["a" /* initTracking */])(__WEBPACK_IMPORTED_MODULE_2_jquery___default()(el));
  });
  initSizeSelector();
});
window.removeCoupon = removeCoupon;
window.applyCouponCode = applyCouponCode;
window.initTracking = __WEBPACK_IMPORTED_MODULE_1__tracking__["a" /* initTracking */];

/***/ })

},[254]);


// WEBPACK FOOTER //
// dist/shoppingbag.js